var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClubSelf = function SvgClubSelf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6971_16208",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7084 10.0003C17.7084 5.74313 14.2573 2.29199 10.0001 2.29199C5.74289 2.29199 2.29175 5.74313 2.29175 10.0003C2.29175 14.2575 5.74289 17.7087 10.0001 17.7087C14.2573 17.7087 17.7084 14.2575 17.7084 10.0003ZM18.9584 10.0003C18.9584 14.9479 14.9476 18.9587 10.0001 18.9587C5.05253 18.9587 1.04175 14.9479 1.04175 10.0003C1.04175 5.05277 5.05253 1.04199 10.0001 1.04199C14.9476 1.04199 18.9584 5.05277 18.9584 10.0003Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0417 10.0003C11.0417 9.42503 10.5754 8.95866 10.0001 8.95866C9.42478 8.95866 8.95841 9.42503 8.95841 10.0003C8.95841 10.5756 9.42478 11.042 10.0001 11.042C10.5754 11.042 11.0417 10.5756 11.0417 10.0003ZM12.2917 10.0003C12.2917 11.266 11.2657 12.292 10.0001 12.292C8.73443 12.292 7.70841 11.266 7.70841 10.0003C7.70841 8.73467 8.73443 7.70866 10.0001 7.70866C11.2657 7.70866 12.2917 8.73467 12.2917 10.0003Z",
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6971_16208)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor"
  }))));
};
export default SvgClubSelf;